import React from 'react'

// CardCurrencyBrandIntroACDC returns an introduction for the ACDC card brand currency table.
// CardCurrencyBrandIntroACDC takes no input.

const CardCurrencyBrandIntroACDC = () => {
  return (
    <>
      <p>
        Expanded Checkout payments are available for 37 countries and 22
        currencies.
      </p>
      <p>
        Select the <strong>Card brand currency table</strong> and scroll or use
        the search bar to find details about the card brands and currencies
        supported in each country:
      </p>
    </>
  )
}

export default CardCurrencyBrandIntroACDC
